/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { Button, Collapse, Link } from '@material-ui/core'
import { Body1, Body2, Header1, Header2, SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import Instruction from '@flatsy/core/Content/Instruction'
import {
  bedroomsFormat,
  floorFormat,
  roomsFormat,
  surfaceFormat,
} from '@flatsy/utils/Functions/format/Conversions'
import SquareFootIcon from '@material-ui/icons/SquareFoot'
import LayersOutlinedIcon from '@material-ui/icons/LayersOutlined'
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined'
import { priceValue } from '@flatsy/utils/Functions/format/Conversions'
import FormatPrice from '@flatsy/core/Format/Price'
import theme from '@flatsy/core/MuiTheme/theme'
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined'
import EventIcon from '@material-ui/icons/Event'
import clsx from 'clsx'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import { bodyScroll } from '@flatsy/utils/Functions/RemoveBodyScroll'
import i18n from '@flatsy/utils/translations'
import Carousel from '../../Carousel'
import useStyles from './Style'
import { componentProps } from './Type'
import { findBookingDate } from './Utils'
import TopBar from './TopBar'

const QualificationSideBarMobile: React.FC<componentProps> = ({
  asset,
  application,
  booking,
  useInstruction,
  bottomComponent,
  withRadius,
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    if (asset) {
      setOpen(!open)
      if (!open) {
        bodyScroll.remove()
      } else {
        bodyScroll.add()
      }
    }
  }

  const hasBooking = findBookingDate({ booking, application })
  const renderButtonBar = () => (
    <TopBar open={open} asset={asset} handleOpen={handleOpen} withRadius={withRadius} />
  )

  const renderBedrooms = () => {
    if (asset?.bedrooms || asset?.bedrooms === 0) {
      return (
        <div className={classes.row}>
          <HotelOutlinedIcon className={classes.icon} />
          <SubBody1 className={classes.iconLabel}>{bedroomsFormat(asset.bedrooms)}</SubBody1>
        </div>
      )
    }
  }

  if (asset) {
    return (
      <>
        {renderButtonBar()}
        <Collapse in={open} className={classes.modal}>
          <div className={classes.wrapper}>
            {renderButtonBar()}
            {useInstruction && booking && <Instruction asset={asset} />}
            <Carousel asset={asset} />
            <div className={classes.sectionWrapper}>
              <div className={classes.section}>
                <div>
                  <Header1 lowerCase>
                    {asset && <FormatPrice format="00.[00]$" price={priceValue(asset)} />}{' '}
                    {!asset?.is_sale && i18n.t('per_month').toLowerCase()}
                  </Header1>
                  {!asset?.is_sale && (
                    <SubBody1 fontColor={theme.palette.secondary.dark}>
                      {i18n.t('utilities_included').toLowerCase()}
                    </SubBody1>
                  )}
                </div>
                <div>
                  <Header2 fontColor={theme.palette.secondary.dark}>
                    {asset?.address_locality}
                  </Header2>
                  {asset?.ad_url && (
                    <Link href={asset.ad_url} target="_blank">
                      <Body2 fontColor={theme.palette.primary.main}>
                        {i18n.t('view_classified').toLowerCase()}
                      </Body2>
                    </Link>
                  )}
                </div>
              </div>
              {hasBooking && (
                <div className={classes.section}>
                  <div className={classes.row}>
                    <EventIcon className={classes.icon} />
                    <Body1 className={classes.iconLabel}>{hasBooking}</Body1>
                  </div>
                </div>
              )}
              <div className={clsx(classes.section, classes.fourColumnGrid)}>
                <div className={classes.row}>
                  <SquareFootIcon className={classes.icon} />
                  <Body1 className={classes.iconLabel}>{surfaceFormat(asset.surface)}</Body1>
                </div>
                <div className={classes.row}>
                  <LayersOutlinedIcon className={classes.icon} />
                  <Body1 className={classes.iconLabel}>{floorFormat(asset.floor, true)}</Body1>
                </div>
                <div className={classes.row}>
                  <DashboardOutlinedIcon className={classes.icon} />
                  <Body1 className={classes.iconLabel}>{roomsFormat(asset.number_of_rooms)}</Body1>
                </div>
                {renderBedrooms()}
              </div>
              <div className={clsx(classes.section, !bottomComponent && classes.sectionNoBorder)}>
                <div className={classes.row}>
                  <PlaceOutlinedIcon className={classes.icon} />
                  <Body1 className={classes.iconLabel}>{asset?.address_description}</Body1>
                </div>
              </div>
              {bottomComponent && (
                <div className={clsx(classes.section, classes.sectionNoBorder)}>
                  {bottomComponent}
                </div>
              )}
            </div>
            <div className={classes.backButtonWrapper}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpen}
                disableElevation
                className={classes.backButton}
              >
                {i18n.t('back_to_form')}
              </Button>
            </div>
          </div>
        </Collapse>
      </>
    )
  }

  return renderButtonBar()
}

export default QualificationSideBarMobile
